var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDrizzleInitialized)?_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"section"},[_c('Escrow')],1)]):_c('div',[_c('div',[_vm._v("Loading yVesting UI 🐇...")])])}
var staticRenderFns = []

export { render, staticRenderFns }